import React from 'react'
import { twMerge } from 'tailwind-merge'

function DownIcon({className='', size=24, containerClass=''}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={containerClass}>
      <path d="M19.92 8.95001L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.07996 8.95001" stroke="#0C0507" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" className={twMerge('stroke-current',className)}/>
    </svg>
  )
}

export default DownIcon